/** Each ancestor of a folder path paired with its own path, root first — the breadcrumb trail. */
export const folderPathSegments = (folderPath: string): { name: string; path: string }[] =>
  folderPath.split('/').map((name, index, all) => ({
    name,
    path: all.slice(0, index + 1).join('/'),
  }))
